export default function (ev, parent) {
  let offsetX = $(parent).offset().left;
  let offsetY = $(parent).offset().top;
  let scrollTop = $(window).scrollTop();
  return { x: ev.clientX - offsetX, y: ev.clientY + scrollTop - offsetY }
}